import { mapCustomFieldValues } from '@convenia/common-organisms/SystemFields/helpers'
import { masker, mapToNumeric, phoneMasker } from '@convenia/common-organisms/SystemFields/helpers/formatters'
import { camelToSnakeKeys } from '@convenia/helpers'

import { mapFiles } from './upload'
import { ADDRESSES_CONTACTS_AREA } from '../consts'

export const mapAddress = (data = {}, params) => ({
  ...(data || {}),
  zipCode: masker('#####-###', data?.zipCode || ''),
  cityId: Number(data?.city?.id) || null,
  stateId: Number(data?.state?.id) || null,
  files: mapFiles(data?.documentFiles || [], params) || [],
})

export const mapAddressInput = ({ schema, data, invalidFields = [] } = {}) => {
  const {
    zipCode,
    address,
    number,
    complement,
    district,
    cityId,
    stateId,
    entityId,
  } = data || {}

  const body = {
    ...camelToSnakeKeys({
      ...(!invalidFields.includes('zipCode') ? { zipCode: (zipCode || '').replace(/\D+/, '') } : {}),
      ...(!invalidFields.includes('address') ? { address: address || '' } : {}),
      ...(!invalidFields.includes('number') ? { number } : {}),
      ...(!invalidFields.includes('complement') ? { complement: complement || '' } : {}),
      ...(!invalidFields.includes('district') ? { district: district || '' } : {}),
      ...(!invalidFields.includes('cityId') ? { cityId: cityId || null } : {}),
      ...(!invalidFields.includes('stateId') ? { stateId: stateId || null } : {}),
    }),
    custom_fields: mapCustomFieldValues({
      sectionId: ADDRESSES_CONTACTS_AREA.ADDRESS,
      entityId: entityId || undefined,
      data,
      schema
    })
  }

  return body
}

export const mapContacts = (data) => ({
  ...(data || {}),
  cellphone: phoneMasker(data?.personalCellphone),
  telephone: phoneMasker(data?.residentialPhone),
  email: data?.personalEmail || '',
})

export const mapContactInput = ({ schema, data, invalidFields = [] } = {}) => {
  const { telephone, cellphone, email } = data || {}

  return {
    ...camelToSnakeKeys({
      ...(!invalidFields.includes('residentialPhone') ? { residentialPhone: mapToNumeric(telephone) } : {}),
      ...(!invalidFields.includes('personalCellphone') ? { personalCellphone: mapToNumeric(cellphone) } : {}),
      ...(!invalidFields.includes('personalEmail') ? { personalEmail: email || '' } : {}),
    }),
    custom_fields: mapCustomFieldValues({
      sectionId: ADDRESSES_CONTACTS_AREA.CONTACTS,
      data,
      schema
    })
  }
}

export const mapEmergencyContact = (data) => ({
  ...(data || {}),
  emergencyContactRelationId: data?.emergencyContactRelation?.id,
  relation: data?.emergencyContactRelation?.id,
  telephone: phoneMasker(data?.phone),
  cellphone: phoneMasker(data?.cellphone),
  workPhone: phoneMasker(data?.workPhone),
})

export const mapEmergencyContactInput = ({ entityId, schema, data, invalidFields = [] } = {}) => {
  const {
    emergencyContactRelationId,
    telephone,
    cellphone,
    workPhone,
    email,
    name,
  } = data || {}

  return {
    ...camelToSnakeKeys({
      emergencyContactRelationId,
      ...(!invalidFields.includes('phone') ? { phone: mapToNumeric(telephone) } : {}),
      ...(!invalidFields.includes('cellphone') ? { cellphone: mapToNumeric(cellphone) } : {}),
      ...(!invalidFields.includes('workPhone') ? { workPhone: mapToNumeric(workPhone) } : {}),
      ...(!invalidFields.includes('email') ? { email: email || '' } : {}),
      ...(!invalidFields.includes('name') ? { name: name || '' } : {}),
    }),
    custom_fields: mapCustomFieldValues({
      sectionId: ADDRESSES_CONTACTS_AREA.EMERGENCY_CONTACTS,
      entityId: entityId || data?.entityId,
      data,
      schema
    })
  }
}
